<template>
    <div class="font-main" v-if="TrackingStore.methods.getIsTrackingInit()">
        <router-view :key="$route.path" />
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import { provide } from "vue";
import ConfigManager from "@/config/ConfigManager.js";
//store
import SideMenuStore from "@/store/SideMenuStore.js";
import AccountStore from "@/store/AccountStore.js";
import LocaleStore from "@/store/LocaleStore"
import ModalSetupMixin from '@/mixin/ModalSetupMixin.js';
import TrackingStore from '@/store/TrackingStore'

export default {
    mixins: [ModalSetupMixin],
    provide: {
        SideMenuStore: SideMenuStore,
        AccountStore: AccountStore,
    },
    setup: function(){
        const localeStore = LocaleStore()
        TrackingStore.methods.initTracking()
        provide("LocaleStore", localeStore)
        provide('TrackingStore', TrackingStore)
        
        return {
            TrackingStore
        }
    },
    created: function() {
        console.log("run local environment", ConfigManager.getApi());
        AccountStore.methods.init();
        AccountStore.methods.loginStatus().subscribe(() => {
            if (AccountStore.state.isLogin) {
                console.log('isLogin')
            }
        });

    },
}
</script>
<style lang="scss">
    @import "./style/base/base.scss";
    @import "./style/main.scss";
</style>
